import {
  Companion_getInstance3qgqr058re7xq as Companion_getInstance,
  SerializableAnnotation24zw55nlaus9i as SerializableAnnotation,
  Companion_getInstance2gbof873kqjb4 as Companion_getInstance_0,
} from './VirtualType.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { mapOf2zpbbmyqk8xpf as mapOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import {
  emptyMapr06gerzljqtm as emptyMap,
  mapOf1xd03cq9cnmy8 as mapOf_0,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/collections/Maps.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function DefaultSerializableAnnotationParsers$lambda(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.NaturalSort', mapOf(to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1))));
}
function DefaultSerializableAnnotationParsers$lambda_0(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.AdminSearchFields', mapOf(to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1))));
}
function DefaultSerializableAnnotationParsers$lambda_1(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.AdminTableColumns', mapOf(to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1))));
}
function DefaultSerializableAnnotationParsers$lambda_2(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.AdminTitleFields', mapOf(to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1))));
}
function DefaultSerializableAnnotationParsers$lambda_3(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.services.data.AdminHidden', tmp$ret$0);
}
function DefaultSerializableAnnotationParsers$lambda_4(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.services.data.AdminViewOnly', tmp$ret$0);
}
function DefaultSerializableAnnotationParsers$lambda_5(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.services.data.Multiline', tmp$ret$0);
}
function DefaultSerializableAnnotationParsers$lambda_6(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.UiWidget', mapOf(to('type', Companion_getInstance().invoke_cywwop_k$(it.type_1))));
}
function DefaultSerializableAnnotationParsers$lambda_7(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.JsonSchemaFormat', mapOf(to('format', Companion_getInstance().invoke_cywwop_k$(it.format_1))));
}
function DefaultSerializableAnnotationParsers$lambda_8(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.IntegerRange', mapOf_0([to('min', Companion_getInstance().invoke_cywwop_k$(it.min_1)), to('max', Companion_getInstance().invoke_cywwop_k$(it.max_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_9(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.FloatRange', mapOf_0([to('min', Companion_getInstance().invoke_cywwop_k$(it.min_1)), to('max', Companion_getInstance().invoke_cywwop_k$(it.max_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_10(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.ExpectedPattern', mapOf(to('pattern', Companion_getInstance().invoke_cywwop_k$(it.pattern_1))));
}
function DefaultSerializableAnnotationParsers$lambda_11(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.DisplayName', mapOf(to('text', Companion_getInstance().invoke_cywwop_k$(it.text_1))));
}
function DefaultSerializableAnnotationParsers$lambda_12(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Hint', mapOf(to('text', Companion_getInstance().invoke_cywwop_k$(it.text_1))));
}
function DefaultSerializableAnnotationParsers$lambda_13(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.MimeType', mapOf_0([to('whitelist', Companion_getInstance().invoke_cywwop_k$(it.whitelist_1)), to('blacklist', Companion_getInstance().invoke_cywwop_k$(it.blacklist_1)), to('maxSize', Companion_getInstance().invoke_cywwop_k$(it.maxSize_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_14(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.MaxLength', mapOf_0([to('size', Companion_getInstance().invoke_cywwop_k$(it.size_1)), to('average', Companion_getInstance().invoke_cywwop_k$(it.average_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_15(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.MaxSize', mapOf_0([to('size', Companion_getInstance().invoke_cywwop_k$(it.size_1)), to('average', Companion_getInstance().invoke_cywwop_k$(it.average_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_16(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Denormalized', mapOf(to('calculationId', Companion_getInstance().invoke_cywwop_k$(it.calculationId_1))));
}
function DefaultSerializableAnnotationParsers$lambda_17(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Description', mapOf(to('text', Companion_getInstance().invoke_cywwop_k$(it.text_1))));
}
function DefaultSerializableAnnotationParsers$lambda_18(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.References', mapOf_0([to('references', Companion_getInstance().invoke_cywwop_k$(it.references_1)), to('reverseName', Companion_getInstance().invoke_cywwop_k$(it.reverseName_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_19(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.MultipleReferences', mapOf_0([to('references', Companion_getInstance().invoke_cywwop_k$(it.references_1)), to('reverseName', Companion_getInstance().invoke_cywwop_k$(it.reverseName_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_20(it) {
  // Inline function 'kotlin.collections.mapOf' call
  var tmp$ret$0 = emptyMap();
  return new (SerializableAnnotation())('com.lightningkite.services.data.DoesNotNeedLabel', tmp$ret$0);
}
function DefaultSerializableAnnotationParsers$lambda_21(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Group', mapOf(to('name', Companion_getInstance().invoke_cywwop_k$(it.name_1))));
}
function DefaultSerializableAnnotationParsers$lambda_22(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Sentence', mapOf(to('text', Companion_getInstance().invoke_cywwop_k$(it.text_1))));
}
function DefaultSerializableAnnotationParsers$lambda_23(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Importance', mapOf(to('size', Companion_getInstance().invoke_cywwop_k$(it.size_1))));
}
function DefaultSerializableAnnotationParsers$lambda_24(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.Index', mapOf_0([to('unique', Companion_getInstance().invoke_cywwop_k$(it.unique_1)), to('name', Companion_getInstance().invoke_cywwop_k$(it.name_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_25(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.IndexSet', mapOf_0([to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1)), to('unique', Companion_getInstance().invoke_cywwop_k$(it.unique_1)), to('name', Companion_getInstance().invoke_cywwop_k$(it.name_1))]));
}
function DefaultSerializableAnnotationParsers$lambda_26(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.data.TextIndex', mapOf(to('fields', Companion_getInstance().invoke_cywwop_k$(it.fields_1))));
}
function DefaultSerializableAnnotationParsers$lambda_27(it) {
  return new (SerializableAnnotation())('com.lightningkite.services.database.VectorIndex', mapOf_0([to('dimensions', Companion_getInstance().invoke_cywwop_k$(it.dimensions_1)), to('metric', Companion_getInstance().invoke_cywwop_k$(it.metric_1)), to('sparse', Companion_getInstance().invoke_cywwop_k$(it.sparse_1)), to('indexType', Companion_getInstance().invoke_cywwop_k$(it.indexType_1))]));
}
var DefaultSerializableAnnotationParsersClass;
function DefaultSerializableAnnotationParsers() {
  if (DefaultSerializableAnnotationParsersClass === VOID) {
    class $ {
      constructor() {
        DefaultSerializableAnnotationParsers_instance = this;
        var tmp = Companion_getInstance_0();
        tmp.parser_6f5ibw_k$('com.lightningkite.services.data.NaturalSort', DefaultSerializableAnnotationParsers$lambda);
        var tmp_0 = Companion_getInstance_0();
        tmp_0.parser_6f5ibw_k$('com.lightningkite.services.data.AdminSearchFields', DefaultSerializableAnnotationParsers$lambda_0);
        var tmp_1 = Companion_getInstance_0();
        tmp_1.parser_6f5ibw_k$('com.lightningkite.services.data.AdminTableColumns', DefaultSerializableAnnotationParsers$lambda_1);
        var tmp_2 = Companion_getInstance_0();
        tmp_2.parser_6f5ibw_k$('com.lightningkite.services.data.AdminTitleFields', DefaultSerializableAnnotationParsers$lambda_2);
        var tmp_3 = Companion_getInstance_0();
        tmp_3.parser_6f5ibw_k$('com.lightningkite.services.data.AdminHidden', DefaultSerializableAnnotationParsers$lambda_3);
        var tmp_4 = Companion_getInstance_0();
        tmp_4.parser_6f5ibw_k$('com.lightningkite.services.data.AdminViewOnly', DefaultSerializableAnnotationParsers$lambda_4);
        var tmp_5 = Companion_getInstance_0();
        tmp_5.parser_6f5ibw_k$('com.lightningkite.services.data.Multiline', DefaultSerializableAnnotationParsers$lambda_5);
        var tmp_6 = Companion_getInstance_0();
        tmp_6.parser_6f5ibw_k$('com.lightningkite.services.data.UiWidget', DefaultSerializableAnnotationParsers$lambda_6);
        var tmp_7 = Companion_getInstance_0();
        tmp_7.parser_6f5ibw_k$('com.lightningkite.services.data.JsonSchemaFormat', DefaultSerializableAnnotationParsers$lambda_7);
        var tmp_8 = Companion_getInstance_0();
        tmp_8.parser_6f5ibw_k$('com.lightningkite.services.data.IntegerRange', DefaultSerializableAnnotationParsers$lambda_8);
        var tmp_9 = Companion_getInstance_0();
        tmp_9.parser_6f5ibw_k$('com.lightningkite.services.data.FloatRange', DefaultSerializableAnnotationParsers$lambda_9);
        var tmp_10 = Companion_getInstance_0();
        tmp_10.parser_6f5ibw_k$('com.lightningkite.services.data.ExpectedPattern', DefaultSerializableAnnotationParsers$lambda_10);
        var tmp_11 = Companion_getInstance_0();
        tmp_11.parser_6f5ibw_k$('com.lightningkite.services.data.DisplayName', DefaultSerializableAnnotationParsers$lambda_11);
        var tmp_12 = Companion_getInstance_0();
        tmp_12.parser_6f5ibw_k$('com.lightningkite.services.data.Hint', DefaultSerializableAnnotationParsers$lambda_12);
        var tmp_13 = Companion_getInstance_0();
        tmp_13.parser_6f5ibw_k$('com.lightningkite.services.data.MimeType', DefaultSerializableAnnotationParsers$lambda_13);
        var tmp_14 = Companion_getInstance_0();
        tmp_14.parser_6f5ibw_k$('com.lightningkite.services.data.MaxLength', DefaultSerializableAnnotationParsers$lambda_14);
        var tmp_15 = Companion_getInstance_0();
        tmp_15.parser_6f5ibw_k$('com.lightningkite.services.data.MaxSize', DefaultSerializableAnnotationParsers$lambda_15);
        var tmp_16 = Companion_getInstance_0();
        tmp_16.parser_6f5ibw_k$('com.lightningkite.services.data.Denormalized', DefaultSerializableAnnotationParsers$lambda_16);
        var tmp_17 = Companion_getInstance_0();
        tmp_17.parser_6f5ibw_k$('com.lightningkite.services.data.Description', DefaultSerializableAnnotationParsers$lambda_17);
        var tmp_18 = Companion_getInstance_0();
        tmp_18.parser_6f5ibw_k$('com.lightningkite.services.data.References', DefaultSerializableAnnotationParsers$lambda_18);
        var tmp_19 = Companion_getInstance_0();
        tmp_19.parser_6f5ibw_k$('com.lightningkite.services.data.MultipleReferences', DefaultSerializableAnnotationParsers$lambda_19);
        var tmp_20 = Companion_getInstance_0();
        tmp_20.parser_6f5ibw_k$('com.lightningkite.services.data.DoesNotNeedLabel', DefaultSerializableAnnotationParsers$lambda_20);
        var tmp_21 = Companion_getInstance_0();
        tmp_21.parser_6f5ibw_k$('com.lightningkite.services.data.Group', DefaultSerializableAnnotationParsers$lambda_21);
        var tmp_22 = Companion_getInstance_0();
        tmp_22.parser_6f5ibw_k$('com.lightningkite.services.data.Sentence', DefaultSerializableAnnotationParsers$lambda_22);
        var tmp_23 = Companion_getInstance_0();
        tmp_23.parser_6f5ibw_k$('com.lightningkite.services.data.Importance', DefaultSerializableAnnotationParsers$lambda_23);
        var tmp_24 = Companion_getInstance_0();
        tmp_24.parser_6f5ibw_k$('com.lightningkite.services.data.Index', DefaultSerializableAnnotationParsers$lambda_24);
        var tmp_25 = Companion_getInstance_0();
        tmp_25.parser_6f5ibw_k$('com.lightningkite.services.data.IndexSet', DefaultSerializableAnnotationParsers$lambda_25);
        var tmp_26 = Companion_getInstance_0();
        tmp_26.parser_6f5ibw_k$('com.lightningkite.services.data.TextIndex', DefaultSerializableAnnotationParsers$lambda_26);
        var tmp_27 = Companion_getInstance_0();
        tmp_27.parser_6f5ibw_k$('com.lightningkite.services.database.VectorIndex', DefaultSerializableAnnotationParsers$lambda_27);
      }
    }
    initMetadataForObject($, 'DefaultSerializableAnnotationParsers');
    DefaultSerializableAnnotationParsersClass = $;
  }
  return DefaultSerializableAnnotationParsersClass;
}
var DefaultSerializableAnnotationParsers_instance;
function DefaultSerializableAnnotationParsers_getInstance() {
  if (DefaultSerializableAnnotationParsers_instance === VOID)
    new (DefaultSerializableAnnotationParsers())();
  return DefaultSerializableAnnotationParsers_instance;
}
//region block: exports
export {
  DefaultSerializableAnnotationParsers_getInstance as DefaultSerializableAnnotationParsers_getInstance1th3cnu15ruw9,
};
//endregion

//# sourceMappingURL=DefaultSerializableAnnotationParsers.mjs.map
